export const NAMESPACE = "dashboard"
